class CaesarAlgorithm {
  constructor(setParams) {
    this.setParams = setParams;
  }

  getInputs(params) {
    return <div>No inputs required for Caesar</div>;
  }
}

export default CaesarAlgorithm;